import { createResetableStore } from "~/utils/store";

export default createResetableStore({
    namespaced: true,
    state() {
        return {
            accsessToken: null
        };
    },
    mutations: {
        setAccessToken(state, token){
           state.accsessToken = token;
        }
    }
});